import store from '../store'

const auth = {
  needLogin (route) {
    return route.matched.some(record => record.meta.requiresAuth) && !this.isLogged()
  },

  isLogged () {
    return store.token !== ''
  },

  login (result) {
    store.token = result.data.token
    store.ativo = result.data.ativo
    store.admin = result.data.admin
    store.usuario = result.data.usuario
    store.nome = result.data.nome
    store.refresh = result.refresh
    store.empresa = result.data.nome_empresa
    store.lercancelados = result.data.lercancelados
    store.tempo = result.data.tempo
    store.cancelados = 'NÃO'
    store.modulos = result.data.modulos
    store.tipo = result.data.tipo
    store.tipo_cliente = result.data.tipo_cliente
    store.fk_fornecedor = result.data.fk_fornecedor
  },

  logout () {
    store.token = ''
    store.ativo = ''
    store.admin = ''
    store.usuario = ''
    store.nome = ''
    store.refresh = ''
    store.empresa = ''
    store.lercancelados = ''
    store.tempo = ''
    store.cancelados = ''
    store.modulos = ''
    store.tipo = ''
    store.tipo_cliente = ''
    store.fk_fornecedor = ''
  }
}

export default auth
